import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/state/AppContext";
import { Button } from "@/components/ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function ShareButton({ path, title, testId = "share-btn" }) {
  const { t, tenant } = useApp();

  const share = async () => {
    const url = `${BACKEND}/api/share?tenant=${tenant.slug}&path=${encodeURIComponent(path)}&title=${encodeURIComponent(
      title || "",
    )}`;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (e) {
        // fall through to clipboard
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("brand.shareCopied"));
    } catch (e) {
      toast.success(url);
    }
  };

  return (
    <Button variant="outline" size="sm" className="min-h-11 gap-1 rounded-full" data-testid={testId} onClick={share}>
      <Share2 size={14} /> {t("brand.share")}
    </Button>
  );
}
